export default "__VITE_ASSET__Br2269Ow__"